import colors from 'styles/theme/colors';

const AddressIcon = ({ width = 16, height = 16, color = colors.black100, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={width} height={height} viewBox='0 0 17 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.33301 6.05031C6.33301 6.6161 6.55777 7.15872 6.95784 7.55879C7.35792 7.95887 7.90053 8.18362 8.46632 8.18362C9.03211 8.18362 9.57473 7.95887 9.97481 7.55879C10.3749 7.15872 10.5996 6.6161 10.5996 6.05031C10.5996 5.48452 10.3749 4.9419 9.97481 4.54183C9.57473 4.14175 9.03211 3.91699 8.46632 3.91699C7.90053 3.91699 7.35792 4.14175 6.95784 4.54183C6.55777 4.9419 6.33301 5.48452 6.33301 6.05031Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.46671 1.25C9.73974 1.25 10.9606 1.75571 11.8608 2.65588C12.761 3.55604 13.2667 4.77693 13.2667 6.04996C13.2667 8.36177 9.61728 13.5358 8.68289 14.8229C8.65798 14.8568 8.62544 14.8844 8.58788 14.9035C8.55032 14.9225 8.50881 14.9324 8.46671 14.9324C8.42461 14.9324 8.3831 14.9225 8.34554 14.9035C8.30798 14.8844 8.27543 14.8568 8.25053 14.8229C7.31614 13.5358 3.66675 8.36177 3.66675 6.04996C3.66675 4.77693 4.17246 3.55604 5.07262 2.65588C5.97279 1.75571 7.19368 1.25 8.46671 1.25Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.7186 13.3633C14.6613 13.748 15.9335 14.3901 15.9335 15.1169C15.9335 16.2952 12.5913 17.2502 8.46685 17.2502C4.34244 17.2502 1.00024 16.2952 1.00024 15.1169C1.00024 14.3915 2.26672 13.7508 4.20022 13.3654'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default AddressIcon;
